import { GetterTree } from 'vuex'

import State from './types'

import { IOrderCustomer } from '../orders/types'
import { Category, RootState } from '../types'
export const getters: GetterTree<State, RootState> = {
  customers(state): IOrderCustomer[] {
    const { customers } = state
    return customers || []
  },
  treeCategories(state): Category[] {
    const { treeCategories } = state
    const token = treeCategories || []
    return token
  },
}
